import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Collapse from '@material-ui/core/Collapse';
import { GreenCheckbox } from '../../../components/FlowConfigurationInputs';
import Actions from './Actions';

/**
 * @Description This function lets you return Modules component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
export default function Module({ module, roleID, enable }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState({});
    const [toggle, setToggle] = useState(module.rm_status === 1);
    const initialPermissions = useRef();

    useEffect(() => {
        let permissions = [];
        try {
            permissions = JSON.parse(module.permissions);
            initialPermissions.current = JSON.parse(module.permissions);
        } catch (error) {
            console.log('ERROR', error);
            // console.log(module.module_name);
            // console.log(module.permissions);
        }
        let state = {};
        if(permissions){
            for (const item of permissions) {
                state[item.name] = { selected: item.selected === '1', id: item.id };
            }
        }
        setOpen(state);
    }, []);

    useEffect(() => {
        if (enable.checked) {
            let initial = module.rm_status === 1;
            if (initial !== true) {
                module.statusChange = { status: true, module_id: module.id }
            } else {
                delete module.statusChange;
            }
            setToggle(true);
        }
    }, [enable]);

    const setDifference = () => {
        let willBeAdded = [], willBeDeleted = [];
        for (const item of initialPermissions.current) {
            let condition = item.selected === '1';
            if (open[item.name].selected !== condition) {
                if (open[item.name].selected) { willBeAdded.push(item.id); }
                else { willBeDeleted.push(item.id); }
            } else {
                let index = willBeAdded.indexOf(item.id);
                if (index > -1) { willBeAdded.splice(index, 1); }
                index = willBeDeleted.indexOf(item.id);
                if (index > -1) { willBeDeleted.splice(index, 1); }
            }
        }
        module.willBeAdded = willBeAdded;
        module.willBeDeleted = willBeDeleted;
    }

    const handleChange = (e) => {
        open[e.target.value].selected = e.target.checked;
        setDifference();
        setOpen({ ...open });
    }

    const handleToggleChange = (e) => {
        let checked = e.target.checked;
        let initial = module.rm_status === 1;
        if (checked !== initial) {
            module.statusChange = { status: checked, module_id: module.id }
        } else {
            delete module.statusChange;
        }
        setToggle(checked);
    }

    const handleSelectAll = () => {
        for (const item of initialPermissions.current) {
            open[item.name].selected = true;
        }
        setDifference();
        setOpen({...open});
    }

    const handleDeselectAll = () => {
        for (const item of initialPermissions.current) {
            open[item.name].selected = false;
        }
        setDifference();
        setOpen({...open});
    }

    let style = toggle ? {} : { color: 'gray' };
    return (
        <React.Fragment>
            <TableRow style={{backgroundColor: toggle ? '#F2FFF1': ''}}>
                <TableCell style={{width: 196}}><span className="role-name">{t('CONTENT.MODULE.' + module.module_name)}</span></TableCell>
                <TableCell style={{width: 130}}>
                    <label className="switch">
                        <input type="checkbox" onChange={handleToggleChange} checked={toggle} />
                        <span className="slider round red"/>
                    </label>
                </TableCell>
                <TableCell style={{width: 130}}><button className="role-toggle-all" disabled={!toggle} onClick={handleSelectAll}>{t('CONTENT.ROLE.SELECT-ALL')}</button></TableCell>
                <TableCell style={{width: 130}}><button className="role-toggle-all" disabled={!toggle} onClick={handleDeselectAll}>{t('CONTENT.ROLE.DESELECT-ALL')}</button></TableCell>
                <TableCell>
                    {open.VIEW && <GreenCheckbox size="small" checked={open.VIEW.selected} value="VIEW" onChange={handleChange} disabled={!toggle} style={style}/>}
                </TableCell>
                <TableCell>
                    {open.UPDATE && <GreenCheckbox size="small" checked={open.UPDATE.selected} value="UPDATE" onChange={handleChange} disabled={!toggle} style={style}/>}
                </TableCell>
                <TableCell>
                    {open.DELETE && <GreenCheckbox size="small" checked={open.DELETE.selected} value="DELETE" onChange={handleChange} disabled={!toggle} style={style}/>}
                </TableCell>
                <TableCell>
                    {open.PUBLISH && <GreenCheckbox size="small" checked={open.PUBLISH.selected} value="PUBLISH" onChange={handleChange} disabled={!toggle} style={style}/>}
                </TableCell>
                <TableCell>
                    {open.CREATE && <GreenCheckbox size="small" checked={open.CREATE.selected} value="CREATE" onChange={handleChange} disabled={!toggle} style={style}/>}
                </TableCell>
            </TableRow>
            {(module.library_count && toggle) &&
                <TableRow className="role-actions">
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                        <Collapse in={open.VIEW?.selected && toggle} timeout="auto" unmountOnExit>
                            <Actions module={module} roleID={roleID}/>
                        </Collapse>
                    </TableCell>
                </TableRow>
            }
        </React.Fragment>
    );
}
